// extracted by mini-css-extract-plugin
module.exports = {"group":"FormGroup_group__3A6Qx","label":"FormGroup_label__2znYW"};